import axios from 'axios';
import qs from 'qs';
import cookie from '../cookieHelper/cookie';


// const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/userByEmail/';
// const API_URL = 'http://localhost:8000' + '/api/v1/company';

export default function checkExistingUser(companyId) {
    const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/company/'+companyId;

    // Retrieve the authentication token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);
    return (  
        axios
      .get(API_URL, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json',
        },
      })
        .then(res => {            
            // console.log('companies: ', res.data); 
            return res;
            
        })
        .catch(err => {
            // console.log('errstoris: ' ,err);
            return err;
        })
    )
}